(function() {
  'use strict';

  function BulkActionsCtrl ($mdDialog, mdPanelRef) {
    var ctrl = this;
    ctrl.showDeliveryDialog = function (evt) {
      mdPanelRef.close();
      $mdDialog.show({
        controller: 'DeliveryDialogCtrl',
        controllerAs: 'ctrl',
        template: require('./delivery-dialog.html'),
        parent: angular.element(document.body),
        targetEvent: evt,
        clickOutsideToClose: true,
      })
      .then(function (deliveryType) {
        ctrl.actions.delivery = deliveryType;
      });
    };
    ctrl.showInsuranceDialog = function (evt) {
      mdPanelRef.close();
      $mdDialog.show({
        controller: 'InsuranceDialogCtrl',
        controllerAs: 'ctrl',
        template: require('./insurance-dialog.html'),
        parent: angular.element(document.body),
        targetEvent: evt,
        clickOutsideToClose: true,
      })
      .then(function (insurance) {
        ctrl.actions.insurance = insurance;
      });
    };
    ctrl.showDocumentDialog = function (evt) {
      mdPanelRef.close();
      $mdDialog.show({
        controller: 'DocumentDialogCtrl',
        controllerAs: 'ctrl',
        template: require('./document-dialog.html'),
        parent: angular.element(document.body),
        targetEvent: evt,
        clickOutsideToClose: true,
      })
      .then(function (document) {
        ctrl.actions.document = document;
      });
    };
  }

  angular
    .module('mandaeApp')
    .controller('BulkActionsCtrl', BulkActionsCtrl);

}());
